/**
 * @desc 新建季度计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanQuarterInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/web/plan/quarter/addPlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanQuarterInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/addPlanInfo',
    data,
  });
}
